import { Trait } from "types";
import axios from "axios";
import { apiUrl } from "config";

export const fetchTraits = async (address?: string): Promise<Trait[]> => {
  const res = await axios.get<Trait[]>(`/traits`, {
    baseURL: apiUrl,
    headers: address
      ? {
          Wallet: address,
        }
      : undefined,
  });

  return res.data;
};
